import { useI18n } from '../../i18n/useI18n'

/**
 * 広告 (type='ad') の枠に必ず出す「PR」表記。景品表示法のステマ規制で外せない
 * (お知らせ枠の sponsored と同じ扱い)。カードの中のバナー・ポップアップ・下部の帯の
 * どこに出しても同じ見え方にするため、部品を 1 つにしてある。
 *
 * 写真の上に半透明で重ねると、暗い写真では読めなくなる。**白地に濃い文字**の不透明な
 * ラベルにして、どんな画像でも同じ見え方にする（「一般消費者が容易に認識できる」ことが
 * 表示義務の要件）。
 */
export default function SlotPrLabel() {
  const { t } = useI18n()
  return (
    <span className="absolute left-2 top-2 z-10 rounded bg-white px-2 py-0.5 font-body text-[11px] font-bold tracking-wide text-text-primary shadow">
      {t('announcement.sponsored')}
    </span>
  )
}
